import * as React from "react"
import {Box, Chip, Typography} from "@mui/material";
import {ImageSeeker} from "@ui-seeker/core";

import {useProxiedImage} from "../../../@hooks";


export default function ReverseMatcherImageComparisonModalContainer({ url, fullURL, label, labelColor = 'primary', productName }) {
	const { imageResourceURL } = useProxiedImage(url)
	const __url = fullURL || imageResourceURL

	return <Box
		flex={1}
		minWidth={{ xs: 1, md: 0 }}
		border='1px solid'
		borderColor='divider'
		borderRadius={1}
		display="flex"
		flexDirection="column"
		height={1}
		bgcolor='background.default'
		sx={{
			position: 'relative',
		}}
	>
		<Box position="absolute" top={8} left={8} zIndex={1}>
			{!!label && <Chip size="small" label={label} color={labelColor} sx={{ height: 22 }} />}
		</Box>

		<Box 
			sx={{ 
				width: 1, 
				flex: 1, 
				display: 'flex', 
				alignItems: 'center', 
				justifyContent: 'center',
				overflow: 'hidden',
				p: 1,
				'&:hover .zoomable': {
					transform: 'scale(1.2)',
				},
			}}
		>
			<ImageSeeker
				useSpinner
				lazyLoad={false}
				src={__url}
				sx={{
					width: 1,
					height: 1,
					objectFit: 'contain',
					transition: 'transform .2s ease',
					willChange: 'transform',
					cursor: 'zoom-in',
				}}
				className="zoomable"
			/>
		</Box>
		
		{productName && (
			<Box 
				sx={{ 
					width: 1, 
					p: 2, 
					bgcolor: 'background.paper',
					borderTop: '1px solid',
					borderColor: 'divider',
					flexShrink: 0
				}}
			>
				<Typography 
					variant="body1" 
					fontWeight="bold" 
					align="center"
					sx={{ 
						wordBreak: 'break-word',
						lineHeight: 1.4
					}}
				>
					{productName}
				</Typography>
			</Box>
		)}
	</Box>
}